import './DashboardHeader.css';
import { useAuth } from '../../../hooks/useAuth';
import { OrganizationSwitcher } from '../../../components/OrganizationSwitcher';

interface DashboardHeaderProps {
  title: string;
  userEmail: string;
}

export const DashboardHeader = ({ title, userEmail }: DashboardHeaderProps) => {
  const { isSystemAdmin, isImpersonating, activeOrganization, clearImpersonation } = useAuth();

  return (
    <>
      {isImpersonating && activeOrganization && (
        <div className="dashboard-header__impersonation-banner">
          <span>
            Viewing data as <strong>{activeOrganization.name}</strong>
          </span>
          <button
            className="dashboard-header__impersonation-close"
            onClick={clearImpersonation}
          >
            Return to home
          </button>
        </div>
      )}
      <header className="dashboard-header">
        <h1 className="dashboard-header__title">{title}</h1>
        <div className="dashboard-header__right">
          {isSystemAdmin && <OrganizationSwitcher />}
          <div className="dashboard-header__user">
            <span className="dashboard-header__user-label">Logged in as:</span>
            <span className="dashboard-header__user-email">{userEmail}</span>
          </div>
        </div>
      </header>
    </>
  );
};
